module.exports = "<app-spinner></app-spinner>\n<ng-snotify></ng-snotify>\n<router-outlet></router-outlet>\n\n"